module.exports = __webpack_public_path__ + "img/BLANCO_Capacitacion.271af37f.png";